module.exports = __webpack_public_path__ + "img/img_2.401ef903.png";